import type { ClusteringSettings, PashaBulkaRunSettings } from '../../types/simulation';

/** Default matcher flags for Pasha bulk runs (must match worker `settings.matcher_flags`). */
export const DEFAULT_MATCHER_FLAGS: string[] = [
  'skipRoundTripCheck',
  'matcher-faster-jsprit-convergence',
  'matcher-decrease-ruin-count',
  'activity-time-setter-v2',
  'enable-legacy-path-descriptions',
];

/** Clustering is off by default; the run request omits `clustering` unless `enabled` is true. */
export const DEFAULT_CLUSTERING_SETTINGS: ClusteringSettings = {
  enabled: false,
  cluster_size: 25,
  max_concurrent: 3,
  random_seed: 42,
};

/**
 * Build POST body fields for Pasha run from optional scenario bulk config.
 * `clustering` is only included when the resolved settings have `enabled: true` (worker uses non-clustered Pasha otherwise).
 */
export function pashaRunSettingsFromRunBulk(
  runBulk?: { matcher_flags: string[]; clustering: ClusteringSettings } | null
): PashaBulkaRunSettings {
  const clustering = runBulk?.clustering ?? DEFAULT_CLUSTERING_SETTINGS;
  const out: PashaBulkaRunSettings = {
    matcher_flags: runBulk?.matcher_flags ?? DEFAULT_MATCHER_FLAGS,
  };
  if (clustering.enabled) {
    out.clustering = clustering;
  }
  return out;
}

